export default `vec3 a=vec3(.5, 0.1, 0.2);
    p.z-=55.;
    float s=2., l=0.;
    for(int j=0;j++<8;)
      p=-sign(p)*(abs(abs(abs(p)-2.)-1.)-1.),
      s*=l=-2.12/max(.2,dot(p,p)),
      p=p*l-.55;
    return dot(p,a)/s;
  }`